
import Vue from 'vue'
import Utils from './Utils'

export default {

  pobierz () {
    return Vue.http.get('wiadomosci').then(response => {
      return response.body
    }, Utils.przechwycBlad)
  },

  oznaczJakoPrzeczytana (uuid) {
    return Vue.http.put(`wiadomosci/przeczytane/${uuid}`).then(response => {
      return response
    }, Utils.przechwycBlad)
  }
}
